import produce from 'immer';
import { Reducer } from 'react';
import { Action } from './actions';
import { State } from './state';

const reducer: Reducer<State, Action> = produce((draft, action) => {
  switch (action.type) {
    case 'UPDATE_FILTERS':
      draft.userListFilters = action.payload;
      break;
    case 'SET_PAGE':
      draft.userListPage = action.payload;
      break;
    default:
      throw new Error();
  }
});

export default reducer;
